/**
 * Sort size swatch radios into a logical order, including .5 sizes.
 *  • Handles EU 30–50 and UK 1–16, including .5s.
 *  • Constant‑time lookup via a pre‑built map.
 *  • Uses a DocumentFragment to minimise reflow.
 *  • Wrapped in an IIFE to avoid polluting the global scope.
 *  • Listens on DOMContentLoaded & `shopify:section:load`.
 */

(() => {
  /* -------------------------------------------------------------------- */
  /* Build order map                                                      */
  /* -------------------------------------------------------------------- */

  // Generate EU sizes (30–50) with .5s
  const EU_SIZES = [];
  for (let i = 30; i <= 50; i++) {
    EU_SIZES.push(`EU ${i}`);
    EU_SIZES.push(`EU ${i}.5`);
  }

  // Generate UK sizes (1–16) with .5s
  const UK_SIZES = [];
  for (let i = 1; i <= 16; i++) {
    UK_SIZES.push(`UK ${i}`);
    UK_SIZES.push(`UK ${i}.5`);
  }

  const ORDER = [
    "XXXS",
    "XXS",
    "XS",
    "S",
    "M",
    "L",
    "XL",
    "XXL",
    "XXXL",
    "XXXXL",
    ...UK_SIZES,
    ...EU_SIZES,
  ];

  const orderMap = ORDER.reduce((acc, val, idx) => {
    acc[val.toUpperCase()] = idx;
    return acc;
  }, Object.create(null));

  /* -------------------------------------------------------------------- */
  /* Main sorter                                                          */
  /* -------------------------------------------------------------------- */
  const sortSizeSwatches = () => {
    const fieldset = document.querySelector(
      ".variant-wrapper.variant-size.js fieldset.variant-input-wrap"
    );
    if (!fieldset) return;

    const inputs = Array.from(fieldset.querySelectorAll(".variant-input"));
    if (!inputs.length) return;

    inputs.sort((a, b) => {
      const av = a.getAttribute("data-value")?.trim().toUpperCase() || "";
      const bv = b.getAttribute("data-value")?.trim().toUpperCase() || "";
      const ai = orderMap[av] ?? Infinity;
      const bi = orderMap[bv] ?? Infinity;
      return ai === bi
        ? av.localeCompare(bv, undefined, {
            numeric: true,
            sensitivity: "base",
          })
        : ai - bi;
    });

    // Re-insert with minimal reflow
    const frag = document.createDocumentFragment();
    inputs.forEach((el) => frag.appendChild(el));
    fieldset.appendChild(frag);
  };

  /* -------------------------------------------------------------------- */
  /* Hooks                                                                */
  /* -------------------------------------------------------------------- */
  document.addEventListener("DOMContentLoaded", sortSizeSwatches);
  document.addEventListener("shopify:section:load", sortSizeSwatches);
})();
